







































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTODeviceType } from '@/scripts/services/ClientApiAuto'

@Component<DeviceTypeDialog>({
    validations() {
        return {
          deviceType:{
              Name: {required}
          }
        }
    },
})
export default class DeviceTypeDialog extends CFMDialog {
    deviceType: CFMDTODeviceType = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.deviceType.deviceTypeGetById({id: <number>this.id});
        console.log(res);
        this.deviceType = res.data;
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.deviceType.Id,
        Name: this.deviceType.Name,
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.deviceType.deviceTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
